import { AppEmpresas } from './../../../core/models/appEmpresas.model';
import { AppEmpresasService } from './../../../core/services/appEmpresasService.service';
import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { AppConfig } from '../../../core/configuration/app.config';
import { LicenseCheckerService } from '../../../core/helper/licenseChecker';
import { ImportarExcelDialog } from '../../importar-excel-dialog/importar-excel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { Configuration } from '../../../core/configuration/configuration';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';


/* copia de usurios ARREGLAR */
@Component({
  selector: 'app-empresas-list',
  templateUrl: './empresas-list.component.html',
  styleUrls: ['./empresas-list.component.scss'],
  providers: [AppEmpresasService]
})
export class EmpresasListComponent extends ListFormBase<AppEmpresas> implements AfterViewInit, OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'business'; // Material icon
  panelTitle = 'Empresas';
  panelDescription = 'Listado de los empresas dado un entorno';
  environmentID = this._livesSession.EnvironmentId;

  conectiaLicence: boolean;


  constructor(
    protected _modelService: AppEmpresasService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected appEmpresasService: AppEmpresasService,
    private licenseChecker: LicenseCheckerService,
    protected importExcelDialog: MatDialog,
    private renderer: Renderer2,
    private _session: SessionHelper,
    private _livesSession: LivesSessionHelper,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(_modelService, _router, _route, _messageDialog, AppEmpresas);
    this.isCrud = true;
  }

  ngOnInit(): void {
    this.conectiaLicence = this.licenseChecker.checkLicense("conectia");
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource();
    });
  }

  /* comportamiento para que se muestre si/no en vez de un checkbox */
  transformBooleanToYesNo(data: any): string {
    return data && data.enabled ? 'Si' : 'No';
  }

  onClickDisable(data: any) {
    let dataToSend = {
      enabled: !data.data.enabled
    }

    this._messageDialog.ShowQuestion(

      `Se ${data.data.enabled ? `deshabilitará ${data.data.name}. Según las licencias disponibles, no se podrán realizar solicitudes, marcajes o ambas acciones` : `habilitará ${data.data.name}.  Según las licencias disponibles, se podrán realizar solicitudes, marcajes o ambas acciones`}`,
      `${data.data.enabled ? 'Deshabilitar' : 'Habilitar'}`
    )
      .then(result => {
        if (result.value) {
          this.appEmpresasService.updateModel(data.data.company1, dataToSend).subscribe(
            (result) => {

              setTimeout(() => {
                this.getDataSource();
              }, 1500);
            },
            (error) => {
              this._messageDialog.ShowAlert(
                `Se ha producido un error al ${data.data.enabled ? 'deshabilitar' : 'habilitar'} la empresa ${data.data.name}`,
                `Error al ${data.data.enabled ? 'deshabilitar' : 'habilitar'} empresa`);

              console.error(`Error al ${data.data.enabled ? 'deshabilitar' : 'habilitar'} ${data.data.name}:`, error);
            }

          )
        }
      });
  }

  onClickImport() {
    const dialogRef = this.importExcelDialog.open(ImportarExcelDialog, {
      width: '50%',
      data: { templateType: 'companies' },
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.getDataSource();
    });
  }

  isAdmin() {
    return this._session.User.Roles?.includes(Configuration.rolAdministrador) || false
  }

}